import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { system } from 'styled-system';
const LoaderContainer = styled.svg.withConfig({
  displayName: "LoaderContainer",
  componentId: "sc-8w75by-0"
})(["&&&{display:block;width:", ";height:", ";}"], p => p.width || 'auto', p => p.height || 'auto');
const hex1animation = keyframes(["0%{transform:scale(.1);}7.5%{transform:scale(.075);}15%{transform:scale(.1);}100%{transform:scale(0.4);}0%{opacity:1;}100%{opacity:1;}0%{stroke-width:1;}100%{stroke-width:1;}"]);
const Hex1 = styled.g.withConfig({
  displayName: "Hex1",
  componentId: "sc-8w75by-1"
})(["background:'red';color:'red';animation:", " 1.5s normal infinite linear;transform-origin:50% 50%;", ""], hex1animation, system({
  color: {
    property: 'stroke',
    scale: 'colors'
  }
}));
const hex2animation = keyframes(["0%{transform:scale(0.4);}100%{transform:scale(0.8);}0%{opacity:1;}60%{opacity:0;}100%{opacity:0;}0%{stroke-width:1;}100%{stroke-width:0;}"]);
const Hex2 = styled.g.withConfig({
  displayName: "Hex2",
  componentId: "sc-8w75by-2"
})(["background:#36424a;color:#36424a;animation:", " 1.5s normal infinite linear;transform-origin:50% 50%;", ""], hex2animation, system({
  color: {
    property: 'stroke',
    scale: 'colors'
  }
}));
const hex3animation = keyframes(["0%{transform:scale(.1);}7.5%{transform:scale(.075);}15%{transform:scale(.1);}100%{transform:scale(.1);}0%{stroke-width:8;}100%{stroke-width:8;}"]);
const Hex3 = styled.g.withConfig({
  displayName: "Hex3",
  componentId: "sc-8w75by-3"
})(["background:#36424a;color:#36424a;animation:", " 1.5s normal infinite ease-in;transform-origin:50% 50%;", ""], hex3animation, system({
  color: {
    property: 'stroke',
    scale: 'colors'
  }
}));
export const Loader = _ref => {
  let {
    size,
    color
  } = _ref;
  return React.createElement(LoaderContainer, {
    "enable-background": "new 0 0 85 85",
    width: size,
    height: size,
    viewBox: "0 0 85 85",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement(Hex1, {
    fill: "none",
    color: color,
    "stroke-miterlimit": "10",
    "stroke-width": "5"
  }, React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  }), React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  })), React.createElement(Hex2, {
    fill: "none",
    color: color,
    "stroke-miterlimit": "10",
    "stroke-width": "5"
  }, React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  }), React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  })), React.createElement(Hex3, {
    fill: "none",
    color: color,
    "stroke-miterlimit": "10",
    "stroke-width": "5"
  }, React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  }), React.createElement("path", {
    d: "m70.7 17.9c4.5 2.6 7.3 7.4 7.3 12.6v24c0 5.2-2.8 10-7.3 12.6l-20.8 12c-4.5 2.6-10.1 2.6-14.6 0l-20.8-12c-4.5-2.6-7.3-7.4-7.3-12.6v-24c0-5.2 2.8-10 7.3-12.6l20.7-11.9c4.5-2.6 10.1-2.6 14.6 0z"
  })));
};
Loader.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
Loader.defaultProps = {
  color: '#36424a'
};